<template>
  <div class="feedback-container" style="">
    <el-card class="feedback-card">
      <el-form :model="form"  style="display: flex;flex-wrap: wrap;">
            <el-form-item label="创建时间："  style="display: flex;margin-right: 20px;">
              <el-date-picker
                v-model="form.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期">
              </el-date-picker>
              <span style="margin: 0px 10px;">至</span>
              <el-date-picker
                v-model="form.endDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="提交时间："  style="display: flex;margin-right: 20px;">
              <el-date-picker
                v-model="form.commitDateStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择提交开始">
              </el-date-picker>
              <span style="margin: 0px 10px;">至</span>
              <el-date-picker
                v-model="form.commitDateEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择提交结束">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="学科名称："  style="display: flex;margin-right: 20px;">
              <el-select v-model="form.subject" placeholder="请选择学科" filterable clearable>
                <el-option
                  v-for="item in subjects"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上课老师：" style="display: flex;margin-right: 20px;">
              <el-select v-model="form.teacher" placeholder="请选择老师" filterable clearable>
                <el-option
                  v-for="item in teachers"
                  :key="item.teacherId"
                  :label="item.teacherName"
                  :value="item.teacherId">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="审批状态:：" style="display: flex;margin-right: 20px;">
              <el-select v-model="form.auditStatus" placeholder="请选择审批状态:" filterable clearable>
                <el-option
                  v-for="item in auditStatusList"
                  :key="item.teacherId"
                  :label="item.teacherName"
                  :value="item.teacherId">
                </el-option>
              </el-select>
            </el-form-item>

        <el-row :gutter="20" style="text-align: right; margin-top: 20px;width: 100%;">
          <el-button class="btns" size="small" type="primary" @click="search">搜索</el-button>
          <el-button class="btns" size="small" type="primary" @click="clear">清除</el-button>
          <el-button class="btns" size="small" type="primary" @click="add">添加</el-button>
          <el-button class="btns" size="small" type="primary" @click="exportData">导出</el-button>
        </el-row>
      </el-form>
      <el-table  :data="tableData"  :empty-text="noDataText" height="700"  style="width: 100%; margin-top: 20px; " :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
        <el-table-column prop="studentName" label="学生" width="120"></el-table-column>
        <el-table-column prop="teacherName" label="老师" width="120"></el-table-column>
        <el-table-column prop="categoryName" label="学科" width="120"></el-table-column>
        <el-table-column prop="gradeName" label="年级" width="120"></el-table-column>


        <!-- <el-table-column prop="taskCondition" label="作业完成情况" width="120"></el-table-column>
        <el-table-column prop="examCondition" label="近期考试情况" width="120"></el-table-column>
        <el-table-column prop="classCondition" label="上课吸收情况" width="120"></el-table-column>
        <el-table-column prop="categoryLeaveCondition" label="该学科是否有流失风险" width="200"></el-table-column>
        <el-table-column prop="campusExpression" label="校园表现情况" width="120"></el-table-column>
        <el-table-column prop="spiritFace" label="精神面貌" width="120"></el-table-column>
        <el-table-column prop="categoryExpression" label="学科表现及学习建议" width="200"></el-table-column>
        <el-table-column prop="studyProgressCondition" label="学生进步情况" width="120"></el-table-column> -->

        <el-table-column prop="dataUploading" label="文件" width="200">
          <template slot-scope="scope">
            <div v-for="(itmes,index) in scope.row.dataUploading" :key="index">
              <a :href="itmes.url" :download="itmes.name" target="_blank" rel="noopener noreferrer">{{itmes.name}}</a>
            </div>
          </template>
        </el-table-column>

         <el-table-column prop="auditStatus" label="审批状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.auditStatus == 0">待提交</span>
            <span v-if="scope.row.auditStatus == 1">审批中</span>
            <span v-if="scope.row.auditStatus == 2">已完成</span>
            <span v-if="scope.row.auditStatus == 3">驳回</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
        <el-table-column prop="commitDate" label="提交时间" width="200"></el-table-column>
        <el-table-column prop="createName" label="创建人" width="120"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="handleView(scope.$index, scope.row)" type="text"  size="small">查看</el-button>
            <el-button @click="handleEdit(scope.$index, scope.row)" type="text"  size="small">编辑</el-button>
            <el-button @click="handleDelete(scope.$index, scope.row)" type="text"  size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container" style="text-align: center; margin-top: 20px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

    </el-card>



    <el-dialog :visible="showpopLong" center :title="showpopLongtitle" modal-append-to-body append-to-body :close-no-click-modal="false" :before-close="showpopLongCloseDialog" width="60%" >
      <isshowpopLong :studentData="studentData" :dataRow="dataRow" v-if="showpopLong" @handlecancel="handlecancel" :showpopLongtitle="showpopLongtitle"></isshowpopLong>
    </el-dialog>


  </div>
</template>

<script>
import isshowpopLong from "./showpopLong.vue";
import axios from "axios";
import apiBaseUrl from "../../../../config/api";
export default {
  components: {
    isshowpopLong,
  },
  props: {
    studentData: {
      type: Object,
      default: () => {}
    },
    createDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentPage: 1,
      total:0,
      pageSize: 10,
      tableHeight: 400, // 表格高度
      noDataText: '暂无数据', // 无数据时显示的文本
      auditStatusList:[
        {
          teacherId: '0',
          teacherName: '待提交',
        },
        {
          teacherId: '1',
          teacherName: '审批中',
        },
        {
          teacherId: '2',
          teacherName: '已完成',
        },
        {
          teacherId: '3',
          teacherName: '驳回',
        },
      ],
      form: {
        startDate: '',
        endDate: '',
        subject: '',
        teacher: '',
        auditStatus: '',
        commitDateStart: '',
        commitDateEnd: '',

      },
      subjects: [
        // { value: 'math', label: '数学' },
        // { value: 'english', label: '英语' },
        // { value: 'science', label: '科学' }
      ],
      teachers: [
        // { value: 'teacher1', label: '张老师' },
        // { value: 'teacher2', label: '李老师' },
        // { value: 'teacher3', label: '王老师' }
      ],
      tableData: [
        // 示例数据
        // {
        //   student: '张三',
        //   teacher: '张老师',
        //   subject: '数学',
        //   grade: '三年级',
        //   homeworkCompletion: '已完成',
        //   classAbsorption: '良好',
        //   campusPerformance: '优秀',
        //   recentExam: '95分',
        //   spiritualAppearance: '积极',
        //   createTime: '2023-10-01',
        //   creator: '管理员'
        // },
        // 更多数据...
      ],

      showpopLong: false,
      showpopLongtitle:'',

      dataRow:{},

    };
  },
  computed: {
    paginatedTableData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.tableData.slice(start, end);
    }
  },

  mounted(){
    this.handlestudentDiagnosefindInfo()
    this.getAllAxios()
  },


  methods: {

    getAllAxios() {
      axios.get(`${apiBaseUrl}/studentFeedback/getCategoryList/${this.studentData.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.subjects = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })
      axios.get(`${apiBaseUrl}/studentFeedback/getTeacherList/${this.studentData.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.teachers = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })
    },

    handlestudentDiagnosefindInfo(){
      let data = {
        pageNum: this.currentPage ? this.currentPage : 1,
        pageSize: this.pageSize ? this.pageSize : 10,
        categoryId: this.form.subject ? this.form.subject : null,
        teacherId: this.form.teacher ? this.form.teacher : null,
        createDateStart: this.form.startDate ? this.form.startDate + ' 00:00:00' : null,
        createDateEnd: this.form.endDate ? this.form.endDate + ' 23:59:59': null,
        studentId: this.studentData.id ? this.studentData.id : '',
        commitDateStart: this.form.commitDateStart ? this.form.commitDateStart : null,
        commitDateEnd: this.form.commitDateEnd ? this.form.commitDateEnd : null,
        createDate: this.createDate ? this.createDate : '',
        auditStatus: this.form.auditStatus ? this.form.auditStatus : '',
      }
      axios.post(`${apiBaseUrl}/studentFeedback/findPage`, data, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          if (res.data.code === 200){
              let data = res.data.data

              if(data.records.length > 0){
                 let datas = data.records.map((item) => {
                    if(item.dataUploading){
                       item.dataUploading = JSON.parse(item.dataUploading)
                    }
                    return item
                 })

                 this.tableData = datas.map((item) => {
                   if(item.dataUploading){
                      item.dataUploading.forEach((fileObj) => {
                        fileObj.url = fileObj.url.replace('+', '%2B')
                      })
                   }
                   return item
                 })

              }else{
                this.tableData = []
              }

              this.currentPage = data.current
              this.pageSize = data.size
              this.total = data.total

              this.$message({ type: 'success', message: '获取数据成功!' })
          }else{
            this.$message({ type: 'error', message: '获取数据失败' })
          }

        }).catch((error) => {
          this.$message({ type: 'error', message: error })
      })
    },

    handlecancel() {
      this.showpopLong = false;
      this.handlestudentDiagnosefindInfo()
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.handlestudentDiagnosefindInfo()
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.handlestudentDiagnosefindInfo()
    },
    search() {
      this.handlestudentDiagnosefindInfo()
    },
    clear() {
      // 清除逻辑
      this.form = {
        startDate: '',
        endDate: '',
        subject: '',
        teacher: '',
        auditStatus: '',
        commitDateStart: '',
        commitDateEnd: '',

      }

      this.currentPage = 1
      this.pageSize = 10

      this.handlestudentDiagnosefindInfo()
    },

    showpopLongCloseDialog() {
      this.showpopLongtitle = ''
      this.showpopLong = false
    },
    add() {
      // 添加逻辑
      this.showpopLongtitle = '添加'
      this.dataRow = {}
      this.showpopLong = true
      console.log('添加');
    },
    exportData() {
      let data = {
        pageNum: this.currentPage ? this.currentPage : 1,
        pageSize: this.pageSize ? this.pageSize : 10,
        categoryId: this.form.subject ? this.form.subject : null,
        teacherId: this.form.teacher ? this.form.teacher : null,
        createDateStart: this.form.startDate ? this.form.startDate + ' 00:00:00' : null,
        createDateEnd: this.form.endDate ? this.form.endDate + ' 00:00:00': null,
        studentId: this.studentData.id ? this.studentData.id : null,
        commitDateStart: this.form.commitDateStart ? this.form.commitDateStart : null,
        commitDateEnd: this.form.commitDateEnd ? this.form.commitDateEnd : null,
        auditStatus: this.form.auditStatus ? this.form.auditStatus : '',  
      }
      axios.post(`${apiBaseUrl}/studentFeedback/export`, data, { responseType: "blob", headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel",})
          const downloadLink = document.createElement("a")
          downloadLink.href = URL.createObjectURL(blob)
          downloadLink.download = "综合反馈.xlsx"
          downloadLink.click()
      })

    },
    handleView(index, row) {
      // 查看逻辑
      this.showpopLongtitle = '查看'
      this.dataRow = row
      this.showpopLong = true
      console.log(`查看: row`);
    },
    handleEdit(index, row) {
      this.showpopLongtitle = '编辑'
      this.dataRow = row
      this.showpopLong = true
      // 编辑逻辑
      console.log(row);
    },
    handleDelete(index, row) {
        this.$confirm('再次确认, 是否真的要删除?', '确认', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'error'}).then(() => {
          axios.post(`${apiBaseUrl}/studentFeedback/delete/${row.id}`, {}, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
              if (res.data.code === 200){
                 this.$message({ type: 'success',  message: '删除成功!' });
              }else{
                 this.$message({ type: 'error', message: '删除失败' })
              }
            }).catch((error) => {
              this.$message({ type: 'error', message: error })
          })
        }).catch(() => {
          this.$message({ type: 'info',  message: '已取消删除'  });
        });

    }
  }
};
</script>

<style scoped>
.feedback-container {
  padding: 20px;
}
.feedback-card {
  margin-bottom: 20px;
}
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/subassembly/comprehensiveFeedback.vue